<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import commonTable from '@/components/commonTable2.vue';

export default {
    components: { commonTable },
    data() {
        return {
            typd:false,
            commonTopData: {
                pageName: "newsRelease",
                allel:[],
                clcsfn:(form,n)=>{
                    if(n==0){
                       delete form.templateClassifyId
                    }
                    if(this.commonTopData.tabnums==1){
                        delete form.type
                    }
                },
                allelClfn:(form,da)=>{
 
                    if(this.commonTopData.tabnums==0){
                       form.templateClassifyId = [[da.id]]
                    }
                    if(this.commonTopData.tabnums==1){
                        form.type = [[da.id]]
                    }
                  
                },
                allCheckFn:(da)=>{
                    if([0,1].indexOf(this.commonTopData.tabnums)==-1){
                        return
                    }
                    if(this.$route.query.urlDate){
                        let pd = JSON.parse(this.$route.query.urlDate);
                        if(this.commonTopData.tabnums==0){
                   
                            pd = typeof pd.templateClassifyId=='string'?pd.templateClassifyId.split(','):pd.templateClassifyId;
                        }
                        if(this.commonTopData.tabnums==1){
                            pd = typeof pd.type=='string'?pd.type.split(','):pd.type;
                        }
                        let op = pd && pd.find(e=>{
                            return e==da.id
                        })
                        console.log((op || op===0)?'io_opd_012check':'')
                        return (op || op===0)?'io_opd_012check':''
                    }
                 
                    return false
                },
                commonleftbtn: [{
                    name: "筛选",
                    fun: "ISshow",
                    is:2
                }],
                commonrightbtn0: [{
                    name: "添加模板",
                    id: "right1",
                    fun: "add",
                    accessid: "201391"
                }],
                commonrightbtn1: [
                    {
                        name: "添加模板",
                        id: "right1",
                        fun: "addProject",
                        accessid: "201391"
                    }
                ],
                commonrightbtn3: [
                    {
                        name: "添加协议类型",
                        id: "right1",
                        fun: "addAgreement",
                        accessid: "201429"
                    }
                ],
                commonrightbtn4: [
                    {
                        name: "添加人员",
                        id: "right1",
                        fun: "addPeople",
                        accessid: "201433"
                    }
                ],
                commonrightbtn5: [
                    {
                        name: "添加分类",
                        id: "right1",
                        fun: "appType",
                        accessid: "201440"
                    }
                ],
                commonbottombtn:[],
                tabData:[
                    {name:"玩法插件",accessid: "201389"},
                    {name:"工程模板",accessid: "201421"},
                    {name:"版本管理",accessid: "201394",type:'version'},
                    {name:"协议管理",accessid: "201426"},
                    {name:"白名单",accessid: "201427"},
                    {name:"分类管理",accessid: "201438"},
                ],
                tabnums:0,
                num:true
            },
            tableConfig: {
                url0:"lockScreenList",
                url1:"lockProjectTemplates",
                url3:"lockscreen_protocolList",
                url4:"lockscreen_whiteIpList",
                url5:"lockscreen_catList",
                title:"添加脚本包模板",
                list0: [
                    {lable:"模板ID",prop:"id"},
                    {lable:"模板名称",prop:"templateName"},
                    {lable:"模板缩略图",prop:"previewPic",type:'imgtou',cls: 'pic-preview'},
                    {lable:"模板分类",prop:"templatesClassifyName"},
                    {lable:"排序权重",prop:"sortWeight"},
                    {lable:"模板脚本包",prop:"fileName"},
                    {lable:"上架状态",prop:"status",type:"keyvalue",child:{"1":"上架","-1":"下架"}},  
                    {lable:"详细说明",prop:"desc"},
                    {lable:"创建时间",prop:"createdAt"},
                ],
                list1:[
                    {lable:"模板ID",prop:"id"},
                    {lable:"模板名称",prop:"name"},
                    {lable:"英文名",prop:"enName"},
                    {lable:"模板缩略图",prop:"previewPic",type:'imgtou',cls: 'pic-preview'},
                    {lable:"模板分类",prop:"type", type:"moban_type"},
                    {lable:"排序权重",prop:"sortWeight"},
                    // {lable:"模板分类",prop:"type"},
                    // {lable:"模板脚本包",prop:"fileName"},
                    {lable:"上架状态",prop:"status",type:"keytype",child:{"1":"上架","-1":"下架"}}, 
                    {lable:"详细说明",prop:"desc"},
                    {lable:"创建时间",prop:"createdAt"},
                ],
                list3:[
                    {lable:"协议模板ID",prop:"id"},
                    {lable:"协议模板名称",prop:"name"},
                    {lable:"创建时间",prop:"created_at"},
                    {lable:"更新时间",prop:"updated_at"},
                ],
                list4:[
                    {lable:"用户ID",prop:"open_id"},
                    {lable:"用户昵称",prop:"username"},
                    {lable:"备注",prop:"remark"},
                    {lable:"手机号",prop:"mobile"},
                    {lable:"添加时间",prop:"created_at"},
                    {lable:"白名单范围",prop:"template_permissions_name",type:'white_name'},
                    {lable:"本地下载权限",prop:"is_local_download",type:"keyvalue",child:{"0":"关闭","1":"开启"}},
                    {lable:"是否加密",prop:"is_encrypt",type:"keyvalue",child:{"0":"关闭","1":"开启"}},
                    {lable:"本地查看权限",prop:"is_local_view",type:"keyvalue",child:{"0":"关闭","1":"开启"}},
                    {lable:"本地打开权限",prop:"is_local_upload",type:"keyvalue",child:{"0":"关闭","1":"开启"}},
                ],
                list5:[
                    {lable:"分类ID",prop:"id"},
                    {lable:"分类名称",prop:"cate"},
                    {lable:"所属分类",prop:"type", type:"backData", backfn:(da)=>{
                        let map = {
                            "2":"工程模板",
                            "1":"玩法插件"
                        }
                        return map[da.type] ? map[da.type] : '未知'
                    }},
                    {lable:"所属父级节点",prop:"pid_path", type:"backData", backfn:da=> {
                        return da.type == 2 ? '' : da.pid_path
                    }},
                    {lable:"权重",prop:"sort_weight"},
                    {lable:"权限范围",prop:"is_visible", type:"backData", backfn:da=> {
                        let map = {
                            "0": "私有",
                            "1": "公共"
                        }
                        return map[da.is_visible] ? map[da.is_visible] : '未知'
                    }},
                    {lable:"上下架状态",prop:"status", type:"backData", backfn:(da)=> {
                        let map = {
                            "0":"待上架",
                            "1":"上架",
                            "-1":"下架"
                        };
                        return map[da.status]?map[da.status]:'未知';
                    }},
                    {lable:"创建时间",prop:"created_at"},
                    {lable:"更新时间",prop:"updated_at"}
                ]
            },
            tableAction:{
                num:true,
                tableAction0: { 
                    morebtns:{
                        name:()=>{
                            return "编辑"
                        },
                        accessid:"201392",
                        fun:"delect",
                    },
                    del_btn:{
                        accessid:"201392",
                        fun:'delectfn'
                    }
                },
                tableAction1: {
                    morebtns:{
                        name:()=>{
                            return "编辑"
                        },
                        accessid:"201424",
                        fun:"tmpEdit",
                    },
                     del_btn:{
                        accessid:"201424",
                        fun:'delectfn2'
                    }
                },
                tableAction3: {
                    morebtns:{
                        name:()=>{
                            return "编辑"
                        },
                        accessid:"201430",
                        fun:"xieyi_tmpEdit",
                    },
                    del_btn:{
                        name:()=>{
                            return "删除"
                        },
                        accessid:"201431",
                        fun:"tmpDel",
                    }
                },
                tableAction4: {
                    morebtns:{
                        name:()=>{
                            return "编辑"
                        },
                        accessid:"201434",
                        fun:"White_list_tmpEdit",
                    },
                    del_btn:{
                        name:()=>{
                            return "删除"
                        },
                        accessid:"201435",
                        fun:"White_list_tmpDel",
                    }
                },
                tableAction5: {
                    morebtns:{
                        name:()=>{
                            return "编辑"
                        },
                        accessid:"201441",
                        fun:"type_list_tmpEdit",
                    },
                    del_btn:{
                        name:()=>{
                            return "删除"
                        },
                        accessid:"201442",
                        fun:"type_list_tmpDel",
                    }
                }
            },
            
            filterFields:{
                filterFields0:[
                    {name:"模板ID",id:"id"},
                    {name:"模板名称",id:"templateName"},
                    {name:"模板分类",type:'cascader',id:"templateClassifyId",child:[],
                    clfn:da=>{

                        if(typeof da.templateClassifyId=='string'){
                            return da.templateClassifyId
                        }
                        if(!da.templateClassifyId){
                            return ''
                        }
                        da.templateClassifyId = da.templateClassifyId.map(e=>{
                            return e[e.length-1]
                        })
                        da.templateClassifyId = da.templateClassifyId.join(',')
                     
                    },
                    optionProps:{
                        label:'cate',
                        value:'id',
                        children:'child',
                        multiple:true,

                    }},
                    {name:"上架状态",id:"status",child:[{name:'上架',id:'1'},{name:'下架',id:'-1'}]},	
                ],
                filterFields1:[
                    {name:"模板ID",id:"id"},
                    {name:"模板名称",id:"name"},
                    {name:"英文名称",id:"en_name"},
                    {name:"模板分类",id:"type",type:'cascader',child:[],
                    clfn:da=>{
                        if(typeof da.type=='string'){
                            return da.type
                        }
                        if(!da.type){
                            return ''
                        }
                        da.type = da.type.map(e=>{
                            return e[e.length-1]
                        })
                        da.type = da.type.join(',')
                    },
                    optionProps:{
                        label:'cate',
                        value:'id',
                        children:'child',
                        multiple:true,
                    }},
                    {name:"上架状态",id:"status",child:[{name:'上架',id:'1'},{name:'下架',id:'-1'}]}
                ],
                filterFields2:[
                    {name:"模板ID",id:"id"},
                    {name:"模板名称",id:"name"},
                    {name:"英文名称",id:"en_name"},
                    {name:"模板分类",id:"type",child:[]},
                    {name:"上架状态",id:"status",child:[{name:'上架',id:'1'},{name:'下架',id:'-1'}]}
                ],
                filterFields3:[
                    {name:"模板ID",id:"id"},
                    {name:"模板名称",id:"name"},
                    {name:"英文名称",id:"en_name"},
                    {name:"模板分类",id:"type",child:[]},
                    {name:"上架状态",id:"status",child:[{name:'上架',id:'1'},{name:'下架',id:'-1'}]}
                ],
                filterFields4:[
                    {name:"用户ID",id:"open_id"},
                    {name:"用户昵称",id:"username"},
                    {name:"备注",id:"remark"},
                    {name:"手机号",id:"mobile"},
                    {name:"添加时间",type:'time',child:[{id:'created_at_start'},{id:'created_at_end'}]},
                    {name:"白名单范围",id:"template_permissions",type:'cascader',child:[],
                    clfn:da=>{
                        if(typeof da.template_permissions=='string'){
                            return da.template_permissions
                        }
                        if(!da.template_permissions){
                            return ''
                        }
                        da.template_permissions = da.template_permissions.map(e=>{
                            return e[e.length-1]
                        })
                        da.template_permissions = da.template_permissions.join(',')
                    },
                    optionProps:{
                        label:'cate',
                        value:'id',
                        children:'child',
                        multiple:true,
                    }},
                   
                   {name:"本地下载权限",id:"is_local_download",child:[{name:'关闭',id:'0'},{name:'开启',id:'1'}]},
                    {name:"是否加密",id:"is_encrypt",child:[{name:'关闭',id:'0'},{name:'开启',id:'1'}]},
                    {name:"本地查看权限",id:"is_local_view",child:[{name:'关闭',id:'0'},{name:'开启',id:'1'}]},
                    {name:"是否脚本包上传权限",id:"is_local_upload",child:[{name:'关闭',id:'0'},{name:'开启',id:'1'}]}
                ],
                filterFields5:[
                    {name:"分类ID",id:"id"},
                    {name:"分类名称",id:"cate"},
                    {name:"所属父级节点",id:"pid", type:'cascader', child: [], optionProps: {label:'cate', value:'id', children:'child', checkStrictly: true},
                        clfn:da=>{
                            da.pid = da.pid && da.pid[da.pid.length-1]
                        }
                    },
                    {name:"所属分类",id:"type", child:[{id: '1', name: '玩法插件'}, {id:' 2', name: '工程模板'}] },
                    {name:"权限范围",id:"is_visible", child:[{id: 1, name: '公共'}, {id: 0, name: '私有'}] },
                    {name:"上下架状态",id:"status", child:[{id: 1, name: '上架'}, {id: -1, name: '下架'}] }
                ]
            },
            form: {
                files: [],
                versionName: '',
                versionCode: '',
            }
        };
    },
    watch:{
        'commonTopData.tabnums'(){
            this.commonTopData.allel = [];
            if(this.commonTopData.tabnums==0){
                this.commonTopData.allel = this.filterFields.filterFields0[2].child;
            }
            if(this.commonTopData.tabnums==1){
                this.commonTopData.allel = this.filterFields.filterFields1[3].child;
            }
        }
    },
    methods: {
        White_list_tmpDel(row){
            this.$alert('确定删除吗？', {
                confirmButtonText: '确定',
                showCancelButton:true,
                callback: action => {
                    if(action=='confirm'){
                        this.api.lockscreen_delWhiteIp({id:row.id}).then(da =>{
                            this.$message({
                                type: 'success',
                                message: da
                            })
                            this.$refs.Tabledd.getTabData()
                        })
                    }
                }
            });
        },
        type_list_tmpDel(row){
            this.$alert('确定删除吗？', {
                confirmButtonText: '确定',
                showCancelButton:true,
                callback: action => {
                    if(action=='confirm'){
                        this.api.lockscreen_delCat({id:row.id}).then(da =>{
                            this.$message({
                                type: 'success',
                                message: da
                            })
                            this.$refs.Tabledd.getTabData()
                        })
                    }
                }
            });
        },
        White_list_tmpEdit(row){
            this.$router.push({
                path:"/new/add-people",
                query: {
                    id: row.id,
                    edit: 2
                }
            })
        },
        addPeople(){
            this.setpage()
            this.$router.push({
                path:"/new/add-people"
            })
        },
        type_list_tmpEdit(row){
            this.$router.push({
                path:"/new/add-type",
                query: {
                    id: row.id,
                    edit: 2
                }
            })
        },
        appType() {
            this.setpage()
            this.$router.push({
                path:"/new/add-type"
            })
        },
        xieyi_tmpEdit(row){
            this.$router.push({
                path:"/new/add-agreement",
                query: {
                    id: row.id,
                    edit: 2
                }
            })
        },
        tmpDel(row){
            this.api.lockscreen_delProtocol({id:row.id}).then(da =>{
                this.$message({
                    type: 'success',
                    message: da
                })
                this.$refs.Tabledd.getTabData()
            })
        },
        async getData(){
            const token = localStorage.getItem("access_token")
            let data = await this.api.Lockscreen({
                access_token: token,
                type:1
            })

            if(data) {
                this.filterFields.filterFields0[2].child = data[0].child;
            }
            let data2 = await this.api.Lockscreen({
                access_token: token,
                type:2
            })
            if(data2) {
                this.filterFields.filterFields1[3].child = data2[0].child;
                this.filterFields.filterFields4[5].child = data2[0].child;
            }
            if(this.commonTopData.tabnums==0){
                this.commonTopData.allel = this.filterFields.filterFields0[2].child;
            }
            if(this.commonTopData.tabnums==1){
                this.commonTopData.allel = this.filterFields.filterFields1[3].child;
            }
            if(this.commonTopData.tabnums==5){
                this.filterFields.filterFields5[2].child = data[0].child;
            }
        },
        async getDatanew(){

            const token = localStorage.getItem("access_token")
            let data = await this.api.Lockscreen({
                access_token: token,
                type:1
            })
            if(data) {
                this.filterFields.filterFields0[2].child = data[0].child;
            }
            let data2 = await this.api.Lockscreen({
                access_token: token,
                type:2
            })
            if(data2) {
                this.filterFields.filterFields1[3].child = data2[0].child;
                this.filterFields.filterFields4[5].child = data2[0].child;
            }
        },
        add(){
            this.setpage()
            this.$router.push({
                path:"/new/new-lock-screen"
            })
        },
        addProject(){
            this.setpage()
            this.$router.push({
                path:"/new/new-lock-tmp"
            })
        },
        addAgreement(){
            this.setpage()
            this.$router.push({
                path:"/new/add-agreement"
            })
        },
        ISshow(){
            this.$refs.Tabledd.reject();
        },
        setpage(){
            localStorage.setItem("newsRelease",this.$refs.Tabledd.commonTopData.tabnums);
        },
        async edit(row){
            let status = ""
            if(row.status == 1 ||row.statu=='1'){
                status = -1
            }else{
                status = 1
            }
            let url = 'lockScreenShelve'
            if (row.enName) {
                url = 'shelveProjectTmplate'
            }
            if(row.content){
                 url = 'lockscreen_shelveProtocol'
            }
            if(row.template_permissions_name){
                 url = 'lockscreen_shelveWhiteIp'
            }
            if (row.sort_weight) {
                url = 'lockscreen_shelveCat'
            }

            let data = await this.api[url]({
                access_token: localStorage.getItem("access_token"),
                id: row.id,
                status: status
            })

            if(data) {
                this.$message({
                    type: 'success',
                    message: '成功'
                })
                this.$refs.Tabledd.getTabData();
            }
        },
        delectfn(da){
            if(this.typd){
                this.$message('正在处理请稍后')
                return
            }
 
            this.$confirm('确认删除玩法插件'+da.templateName, '确认修改', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: '',
                center: true
            }).then(() => {
                this.typd = true;
                this.api.Lockdel({
                    id:da.id
                }).then(()=>{
                    this.$refs.Tabledd.getTabData();
                    this.typd = false
                }).catch(()=>{
                    this.typd = false
                })
                
            }).catch(() => {
                
            });
        
        },
        delectfn2(da){
            if(this.typd){
                this.$message('正在处理请稍后')
                return
            }
         
            this.$confirm('确认删除工程模板'+da.name, '确认修改', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								dangerouslyUseHTMLString: true,
								type: '',
								center: true
							}).then(() => {
                                this.typd = true;
                                this.api.delProjectTemplate({
                                    id:da.id
                                }).then(()=>{
                                    console.log('进来了')
                                    this.$refs.Tabledd.getTabData();
                                    this.typd = false
                                }).catch(()=>{
                                    this.typd = false
                                })
								
							}).catch(() => {
								
							});
        
        },
        delect(row){
            this.$router.push({
                path:"/new/new-lock-screen/modify",
                query: {
                    id: row.id,
                    edit: 1
                }
            })
        },
        tmpEdit(row) {
            this.$router.push({
                path:"/new/new-lock-tmp/modify",
                query: {
                    id: row.id,
                    edit: 2
                }
            })
        },
        init() { 
            this.getDownloadUrl()
        },
        async getDownloadUrl() {
            let data = await this.api.getDownloadUrl({
                access_token: localStorage.getItem("access_token")
            })
            if(data) {
                let { lock_screen_file_name: name, lock_screen_kit_size: size, lock_screen_kit_link: url, version_name, version_code} = data
                this.form = {
                    files: [{ name, size, url }],
                    versionName: version_name,
                    versionCode: version_code
                }
            }
        },
        async setLockScreenConfig() {
            let { files, versionName, versionCode } = this.form
            let { size, url, name } = files[0] || {}

            if(versionName === '' || versionCode === '') {
                this.$message.error('请补充完信息')
                return
            }else if(!url) {
                this.$message.error('请上传工具包')
                return
            }
            
            let data = await this.api.setLockScreenConfig({
                lock_screen_kit_link: url,
                lock_screen_kit_size: size,
                lock_screen_file_name: name,
                access_token: localStorage.getItem("access_token"),
                version_name: versionName,
                version_code: versionCode
            })
            if(data) {
                this.$message({
                    type: 'success',
                    message: '锁屏包更新成功'
                })
            }
        },
        fileChange(files) {
            this.form.files = files.slice(-1)
        },
        save() {
            this.setLockScreenConfig()
        }
    },
    mounted() {
        this.getData();
        this.init();
    },
};
</script>
